import styled from "@emotion/styled";

export const NavigationWrapper = styled.div(({theme, showSocialLinks}) => ({
  gridColumn: "1/-1",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  paddingBlock: theme?.breakpoints?.isMobile ? 8 : 16,
  minHeight: "auto",
  zIndex: 1,
  boxSizing: "border-box",
  height: theme?.breakpoints?.isMobile ? 54 : "auto",
}));

export const HeaderInfoWrapper = styled.div(() => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: "row",
}));

export const RightContentWrapper = styled.div(() => ({
  display: "flex",
  gap: 13,
}));

export const BlueUnderline = styled.div(({theme, styles, width}) => ({
  position: "absolute",
  left: 0,
  // top: theme?.breakpoints?.isDesktop ? 52 : theme?.breakpoints?.isMobile ? 52 : 72,
  bottom: 0,
  display: "flex",
  width: width,
  height: 2,
  backgroundColor: theme?.colors?.brandLightBlue,
  WebkitClipPath: "polygon(0% 100%, 0% 0%, 100% 0%, 99% 100%)",
  clipPath: "polygon(0% 100%, 0% 0%, 100% 0%, 99.5% 100%)",
  ...styles,
}));

export const IconWrapper = styled.div(({styles, theme}) => ({
  height: 20,
  width: 20,
  padding: 10,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "0px 0px 16px 0px #1D314014",
  background: "#FFFFFF",
  borderRadius: 100,
  cursor: "pointer",
  alignSelf: "center",
  transition: "box-shadow 0.5s ease",
  ...styles,
  ":hover": {
    boxShadow: "0px 0px 24px 0px rgba(29, 49, 64, 0.16)",
    ".icon": {
      color: theme?.colors?.brandBlue,
    },
  },
}));

export const Icon = styled.img(({width = 20, height = 20}) => ({
  width: width,
  height: height,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
}));
